export const PetFriendly = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='9.004' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5'></circle>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M12 11.625v0a3.001 3.001 0 013.002 3.001v0a1 1 0 01-1 1H9.998a1 1 0 01-1-1v0A3.001 3.001 0 0112 11.625z'
          clipRule='evenodd'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M9 9.374a.25.25 0 10.001.5.25.25 0 00-.002-.5M15.001 9.374a.25.25 0 10.002.5.25.25 0 00-.002-.5M12 8.374a.25.25 0 10.002.5.25.25 0 00-.002-.5'
        ></path>
      </svg>
    </span>
  );
};
